import { isAppHome } from '@/services/deviceService';
import { requestNative } from '@/services/appBridge';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Divider, List, ListItem, ListItemText, Switch, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { GlobalStateContext } from '@/context/GlobalContextProvider';
import { useTranslation } from 'react-i18next';
import { biz3utils } from '@/utils/biz3utils';
import { DeferredLoading } from './deferredComponent';

const MobileDeviceNotifyCenter = () => {
  const { gManageDevice, setSnackbarValue } = useContext(GlobalStateContext);
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [pushToken, setPushToken] = useState(isAppHome ? null : searchParams.get('pushToken'));
  useEffect(() => {
    if (isAppHome)
      requestNative('pushInfo')
        .then(({ data }) => setPushToken(data.pushToken))
        .catch((error) => {
          setLoading(false);
          setSnackbarValue({
            logScope: 'components/MobileDeviceNotifyCenter.MobileDeviceNotifyCenter',
            severity: 'error',
            open: true,
            msg: error.message,
          });
        });
  }, []);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!pushToken) {
      if (!isAppHome) setLoading(false);
      return;
    }
    setLoading(true);
    gManageDevice.getDevicesNotifyStatus({ pushToken }, (res) => {
      setLoading(false);
      if (!res.success) {
        setSnackbarValue({
          logScope: 'components/MobileDeviceNotifyCenter.MobileDeviceNotifyCenter',
          logReason: 'appHome.networkError',
          severity: 'error',
          open: true,
          msg: res.message || t('appHome.networkError'),
        });
        return;
      }
      setDevices(res.data);
    });
  }, [pushToken]);

  const handleEnablePush = useCallback(({ pushToken, deviceUUID, enablePush }) => {
    gManageDevice.switchDeviceNotify({ pushToken, deviceUUID, enablePush }, (res) => {
      if (!res.success) {
        setSnackbarValue({
          logScope: 'components/MobileDeviceNotifyCenter.handleEnablePush',
          logReason: 'appHome.networkError',
          severity: 'error',
          open: true,
          msg: res.message || t('appHome.networkError'),
        });
        return;
      }
      setDevices((preState) => {
        return preState.map((device) =>
          device.deviceUUID === deviceUUID ? { ...device, enablePush: enablePush } : device
        );
      });
    });
  });

  const handleOpenSystemNotificationSettings = useCallback(() => {
    biz3utils.triggerBridge({
      action: 'requestNotificationSettings',
    });
  }, []);

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {loading && <DeferredLoading />}
      <List disablePadding>
        {devices.length > 0 && (
          <Box sx={{ bgcolor: 'secondary.light', p: 2 }}>
            <Typography
              onClick={handleOpenSystemNotificationSettings}
              sx={{
                fontWeight: 'bold',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              {t('pages.sesameAccessControlDevice.index.NotifyCenterHint')}
            </Typography>
          </Box>
        )}
        {devices.map((device, index) => (
          <React.Fragment key={device.deviceUUID}>
            <ListItem>
              <ListItemText primary={device.deviceName} sx={{ flex: 1 }} />
              <Switch
                edge="end"
                checked={device.enablePush}
                onChange={(event) => {
                  handleEnablePush({ pushToken, deviceUUID: device.deviceUUID, enablePush: event.target.checked });
                }}
              />
            </ListItem>
            {index < devices.length - 1 && <Divider light variant="middle" />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default MobileDeviceNotifyCenter;
